function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".share-youtube_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"));

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  className: "share-youtube_svg__a",
  x: 0.5,
  y: 12.5,
  width: 22,
  height: 11,
  rx: 4,
  ry: 4
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "share-youtube_svg__a",
  d: "M3.5 1l3 4 .001 4.502"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "share-youtube_svg__a",
  d: "M9.5 1l-3 4 .001 4.502M12.5 8a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 3 0zM18.5 3.5v4a2 2 0 0 1-4 0v-4M18.5 3.497V9.5M10.5 16.497V20.5M3.479 15.5h4.042M5.5 15.5v4.978M12.5 14.5v5.978M14.5 19.5a1 1 0 0 1-2 0v-2a1 1 0 0 1 2 0zM8.5 16.5v3a1 1 0 0 0 2 0v-3M18.672 19.625a.978.978 0 0 1-1.086.875 1.19 1.19 0 0 1-1.086-1.125V17.5a1 1 0 0 1 2 0v1h-2"
});

const SvgShareYoutube = props => /*#__PURE__*/React.createElement(Svg, _extends({
  viewBox: "0 0 24 24"
}, props), _ref, _ref2, _ref3, _ref4);

export default SvgShareYoutube;